import MISReport from "../MISReport";

export default function MISReportPage({ sessionObject }) {
  // if (!sessionObject.sessionVariables["modules"].includes("mis-report")) {
  //   return;
  // }
  return (
    <div className="page-bilty">
      <MISReport sessionObject={sessionObject} />
    </div>
  );
}